/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';

import {
  MIME_TYPE_DESCRIPTIONS,
  ALLOWED_EXTENSIONS,
} from 'eflex/constants/file-types';

export default class WorkInstructionEditorLibraryCard extends Component {
  @service intl;
  @service currentUser;

  @tracked isDragOver = false;

  supportedFileTypes = ALLOWED_EXTENSIONS;

  get libraryItem() {
    if (this.args.libraryItem) {
      return this.args.libraryItem;
    } else {
      return { isReturnHomeCard: true };
    }
  }

  get isDraggable() {
    if (this.args.isDraggable !== undefined) {
      return this.args.isDraggable();
    }

    return true;
  }

  get iconThumbnail() {
    if (this.libraryItem.isInstruction) {
      return null;
    } else if (this.libraryItem.mime === 'application/pdf') {
      return 'file-pdf';
    } else if (this.libraryItem.mime === 'text/html') {
      return 'file-code';
    } else {
      return 'file';
    }
  }

  get imageThumbnail() {
    if (this.libraryItem.isFolder) {
      return null;
    }

    if (this.args.isReadOnly) {
      return this.libraryItem.deployedImageThumbUrl;
    } else {
      return this.libraryItem.displayImageThumbUrl;
    }
  }

  get instructionName() {
    if (this.libraryItem.isFolder) {
      return null;
    }

    if (this.args.isReadOnly && this.libraryItem.deployedName) {
      return this.libraryItem.deployedName;
    } else {
      return this.libraryItem.name;
    }
  }

  get fileTypeDescription() {
    const description = MIME_TYPE_DESCRIPTIONS[this.libraryItem.mime];
    return this.intl.t(description ?? 'fileTypeDescription.undefined');
  }

  review = (mode) => {
    this.args.setCardSelectedTrue(this.libraryItem);
    this.args.openReviewModal(mode, this.libraryItem);
  };

  deploy = () => {
    this.args.setCardSelectedTrue(this.libraryItem);
    this.args.openDeployModal();
  };

  @action
  onDragOver() {
    if (this.args.isReadOnly) {
      return;
    }

    this.isDragOver = true;
  }

  @action
  onDragOut() {
    if (this.args.isReadOnly) {
      return;
    }

    this.isDragOver = false;
  }

  @action
  dropOnFolder(folder) {
    if (this.args.isReadOnly) {
      return;
    }

    this.args.dropOnFolder?.(folder);
  }
}
